module.exports = __webpack_public_path__ + "img/FreeTraining-1.d8b8c883.png";